"use strict";

var curry = require("./curry.js");

var takeAll = require("./takeAll.js");

var go1 = require("./go1.js");

var take = require("./take.js");

module.exports = curry(function dropRight(l, iter) {
  return go1(takeAll(iter), arr => take(arr.length - l, arr));
});